export const getFromLocation = (location) => ({
  name: location.state && location.state.from && location.state.from.name,
  url: location.state && location.state.from && location.state.from.url,
});
